<template>
	<transition-group
		name="toast"
		tag="div"
		class="pointer-events-none fixed inset-x-4 bottom-4 z-[1060] flex max-w-full flex-col-reverse items-end md:left-auto md:max-w-[min(48rem,calc(100vw-2rem))]"
	>
		<Toast
			v-for="(toast, index) in $store.state.toast.toasts"
			:key="toast.id"
			:title="toast.title"
			:message="toast.message"
			:type="toast.type"
			:icon="toast.icon"
			:theme="toast.theme"
			:persist="toast.persist"
			:lifetime="toast.lifetime"
			@dismiss="$store.dispatch('toast/dismiss', toast)"
			class="mb-2 w-full max-w-full cursor-pointer pointer-events-auto md:min-w-[20rem] md:w-auto md:max-w-[min(48rem,calc(100vw-2rem))]"
			:style="{ zIndex: -index }"
		>
		</Toast>
	</transition-group>
</template>

<script>
import Toast from '~/components/ui/common/Toast'

export default {
	components: {
		Toast
	}
}
</script>
